module.exports = __webpack_public_path__ + "static/Set-Style-MT-6c24e371c7e203a9d83b300ce7c17a7a.png";